export enum Gender {
	Man = 0,
	Woman = 1,
	Other = 2
}